import { VariantProps, cva } from 'class-variance-authority';
import { getTypographyVariantClasses } from '../atoms/typography/variants';

export const input = cva(
  [
    'flex',
    'transition-colors',
    'duration-200',
    'ease-out',
    'items-center',
    'leading-1',
    'border',
    'border-grayscale200',
    'w-full',
    'placeholder:text-grayscale300',
    'text-grayscale500',
    'hover:border-primaryMain',
    'focus-visible:border-primaryMain',
    'focus-visible:bg-primary50',
    'focus-within:border-primaryMain',
    'focus-within:bg-primary50',
    'outline-none',
  ],
  {
    variants: {
      size: {
        large: [
          'px-20 min-h-64 rounded-12',
          getTypographyVariantClasses('body-m'),
        ],
        default: [
          'px-16 min-h-48 py-12 rounded-6',
          getTypographyVariantClasses('body-m'),
        ],
        small: ['p-8 rounded-6', getTypographyVariantClasses('body-s')],
      },
    },
    defaultVariants: {
      size: 'default',
    },
  },
);

export type InputVariants = VariantProps<typeof input>;
